<template>
  <div>
    <b-row align-v="center">
      <b-col class="p-0">
        <CheckBoxConfiguration
          id="mapping-checkbox"
          :controller="MappingCtller"
          :disabled="!isMappingSetReportViewer"
          :switchprop="true"
        />
        <b-tooltip
          v-if="!isMappingSetReportViewer"
          target="mapping-checkbox"
          placement="bottom"
        >
          Requires mapping values on the datalines
        </b-tooltip>
      </b-col>
      <b-col
        v-if="MappingCtller.value"
        class="m-0 p-0"
        cols="2"
      >
        <b-button
          size="sm"
          variant="outline-primary"
          class="m-0 p-0"
          @click="MappingExpanded=!MappingExpanded"
        >
          <b-icon
            v-if="MappingExpanded"
            aria-label="More"
            icon="caret-up"
          />
          <b-icon
            v-else
            aria-label="More"
            icon="caret-down"
          />
        </b-button>
      </b-col>
    </b-row>
    <b-row v-if="MappingCtller.value">
      <b-collapse
        v-model="MappingExpanded"
        class="ml-5 mb-2 expanded-info p-1 pr-4"
      >
        <DropdownConfiguration
          class="ml-2"
          :controller="MappingScanDropCtller"
        />
      </b-collapse>
    </b-row>
  </div>
</template>

<script>
import CheckBoxConfiguration from '../elements/CheckBoxConfiguration'
import DropdownConfiguration from '../elements/DropdownConfiguration'
import {checkBoxGraphConfCtrller,comboBoxConfCtrller} from '@/assets/classes/configuration.js'
import { ConfigName, ExtraConfigKey, NameExtraConfig } from '@/common/sharedDefinitions/commonPlotDefinitions'
import { mapGetters } from 'vuex'

const zoneNotify='Mapping'
const rootContextFolder = 'ReportViewer/' + zoneNotify

export default {
  name: 'MappingFit',
  components:{
    CheckBoxConfiguration,
    DropdownConfiguration,
  },
  props: { 
    sectionconfig:{
      type:String,
      required: true
    },
  },
  data() {
    return {
      ConfigName,
      ExtraConfigKey,
      NameExtraConfig,
      elementsConfig: [],
      MappingCtller: new checkBoxGraphConfCtrller(`${ConfigName.BaseAxisProperties}.${ConfigName.MappingDiscrete}`,'Spacial Mapping',false,rootContextFolder+'SpacialMapping'),
      MappingScanDropCtller: new comboBoxConfCtrller(`${ConfigName.BaseAxisProperties}.${ConfigName.MappingScanDiscrete}`,[],'Scan Selected',0,rootContextFolder+'MappingScan'),
      MappingExpanded:true,
    }
  },
  computed:mapGetters([
    'getScanFilesListReportViewer',
    'isMappingSetReportViewer',
    'getCurrentReportViewer'
  ]),
  watch:{
    getScanFilesListReportViewer(){
      this.MappingScanDropCtller.options = this.getScanFilesListReportViewer
      this.MappingScanDropCtller.setParent(this)
    },
  },
  mounted(){
    this.configureStudy()
    this.isVisibleReverseCurrent = typeof(this.getCurrentReportViewer[ExtraConfigKey][NameExtraConfig.ReverseCurrentPresent])!=='undefined' && this.getCurrentReportViewer[ExtraConfigKey][NameExtraConfig.ReverseCurrentPresent]
  },
  methods: {
    configureStudy(){
      this.elementsConfig = [
        this.MappingCtller,
        this.MappingScanDropCtller,
      ]
      this.MappingScanDropCtller.options = this.getScanFilesListReportViewer
      this.elementsConfig.forEach(conf=>conf.configCategory=this.sectionconfig)
      this.elementsConfig.forEach(conf=>conf.setParent(this))
    }
  }
}
</script>

<style>

</style>